// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-popup-toolbar .v-toolbar__content {\n  justify-content: space-between;\n  height: 28px !important;\n  padding-left: 0px;\n  padding-right: 0px; /* button has 12px of right padding */\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
